(ns manage.adset-activation-table.view
  (:require ["@mui/x-data-grid-premium" :refer [DataGridPremium GridActionsCellItem]]
            [common.validators.core :refer [url?]]
            [manage.adset-activation-table.db]
            [manage.content-variant-page.table.view :refer [preview-asset]]
            [manage.resource.adset-activation :as resource]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn get-row [path _value row ^js _column ^js _apiRef]
  (get-in row path))

(defn preview-cell-renderer [type ^js params]
  (let [value (or (js->clj (.-value params)) "")]
    (if (url? value)
      ($ preview-asset {:type type :value value})
      value)))

(defn get-actions [^js o]
  (let [row (.-row o)
        {:keys [enabled id]} row]
    #js [($ GridActionsCellItem
            {:onClick (fn [_]
                        (js/Promise.
                         (fn [resolve reject]
                           (rf/dispatch [::resource/update-activation resolve reject id (not enabled)]))))
             :label (if enabled "Disable" "Enable")
             :showInMenu true})]))

(def ^:private columns
  #js [#js {:field "Label"
            :width 300
            :valueGetter (partial get-row [:data :reporting-label])}
       #js {:field "Status"
            :width 80
            :valueGetter (partial get-row [:sync-data :status])}
       #js {:field "Enabled"
            :valueGetter (partial get-row [:enabled])}
       #js {:field "Orphan"
            :valueGetter (partial get-row [:orphan])}
       #js {:field "Active"
            :valueGetter (partial get-row [:active])}
       #js {:field "Image"
            :valueGetter (partial get-row [:data :image-uri])
            :renderCell (partial preview-cell-renderer "image")}
       #js {:field "Video"
            :valueGetter (partial get-row [:data :video-uri])
            :renderCell (partial preview-cell-renderer "video")}
       #js {:field "Published Ad id"
            :valueGetter (partial get-row [:sync-data :published-facebook-ad-id])}
       #js {:field "FB adset id"
            :valueGetter (partial get-row [:data :facebook-adset-id])}
       #js {:field "Title"
            :valueGetter (partial get-row [:data :meta-headline])}
       #js {:field "Message"
            :valueGetter (partial get-row [:data :meta-primary-text])}
       #js {:field "Description"
            :valueGetter (partial get-row [:data :meta-description])}
       #js {:field "CTA"
            :valueGetter (partial get-row [:data :meta-cta])}
       #js {:field "CTA link"
            :valueGetter (partial get-row [:data :meta-cta-link])}
       #js {:field "Actions"
            :type "actions"
            :column-type "actions"
            :width 16
            :getActions get-actions}])

(defui activation-data-grid []
  (let [adset-activation-rows (use-subscribe [:resource.adset-activation/all])
        get-row-id (fn [row] (:id row))]
    ($ DataGridPremium
       {:columns columns
        :rows (to-array (or adset-activation-rows []))
        :getRowId get-row-id})))
